import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#face-worried-clip0_2249_1732)" }, [
      _createElementVNode("path", {
        fill: "currentColor",
        "fill-rule": "evenodd",
        d: "M4.997 0a1 1 0 0 1 .744.33l2.483 2.758A10.9 10.9 0 0 1 13 2c6.075 0 11 4.925 11 11s-4.925 11-11 11S2 19.075 2 13q.002-.977.165-1.91a5 5 0 0 1-.72-7.635L4.255.331A1 1 0 0 1 4.997 0m4.907 5.995a5 5 0 0 0-.44-1.274A8.9 8.9 0 0 1 13 4a9 9 0 1 1-8.932 7.884 5 5 0 0 0 5.552-3 5 5 0 0 0 .284-2.889m-4.906-3.5L2.916 4.811l-.037.039a3 3 0 1 0 4.205-.038zm6.45 13.61a1 1 0 0 0-.895 0l-2 1a1 1 0 1 0 .894 1.79L11 18.117l1.553.776a1 1 0 0 0 .894 0L15 18.118l1.553.776a1 1 0 1 0 .894-1.788l-2-1a1 1 0 0 0-.894 0L13 16.882zM9 12a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H10a1 1 0 0 1-1-1m7-1a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2z",
        "clip-rule": "evenodd"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "face-worried-clip0_2249_1732" }, [
        _createElementVNode("path", {
          fill: "currentColor",
          d: "M0 0h24v24H0z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }